import './icon-set.scss';
import './icon-set.html.twig';
